import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ShowIf = ({ condition, children, }) => _jsx(_Fragment, { children: condition ? children : null });
export default ShowIf;
